import { baseApi } from '@alltrails/redux-helpers';
import type {
  AreaSearchResult,
  FilterSearchResult,
  GuideSearchResult,
  ListSearchResult,
  LocationType,
  PlaceSearchResult,
  POISearchResult,
  TrailSearchResult
} from '../types/algoliaResultTypes';

/**
 * https://github.com/alltrails/explore-service/blob/alpha/api/paths/suggestions.yaml#L12
 */
export type SuggestionsParams = {
  limit?: number;
  query: string;
  recordTypesToReturn?: (TrailSearchResult['type'] | Omit<LocationType, 'photospot'> | 'filter' | 'guide' | 'list')[];
};

export type SuggestionsResponse = {
  searchResults: (
    | AreaSearchResult
    | FilterSearchResult
    | GuideSearchResult
    | ListSearchResult
    | PlaceSearchResult
    | POISearchResult
    | TrailSearchResult
  )[];
  summary: {
    count: number;
  };
};

export const suggestionsApi = baseApi.enhanceEndpoints({ addTagTypes: ['Suggestions'] }).injectEndpoints({
  endpoints: builder => ({
    getSuggestions: builder.query<SuggestionsResponse, SuggestionsParams>({
      query: ({ limit, query, recordTypesToReturn }) => {
        return {
          url: `/api/alltrails/explore/v1/suggestions`,
          data: {
            query,
            limit,
            ...(recordTypesToReturn ? { recordTypesToReturn } : {})
          },
          method: 'post'
        };
      }
    })
  })
});

export const { useLazyGetSuggestionsQuery } = suggestionsApi;
